import LmsTable from "../ui/LmsTable";
import {
  useParseRouteActions,
  useFetchData,
} from "../../../helpers/GlobalHelper";
import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";
import { IdProps } from "../../interfaces/Global";
import { LmsEndpoints } from "../../constants/LmsEndpoints";

const LmsCrossCollateralTable = () => {
  const actionsButtons = ["add", "edit", "remove", "export"];
  return (
    <LmsTable
      actionButtons={actionsButtons}
      apiSuffix="menu/cross-collateral"
      deleteSuffix="menu/cross-collateral"
      />
  );
};

const addCrossCollateralFields = (myForm) => {
  myForm.addCenteredGroup([
    myForm.getDropdownField("Loan", LmsEndpoints.Loans.GET.LIST_LOANS, {
      required: true,
      dropdownMultiple: true
    }),
  ]);

  myForm.addCenteredGroup([myForm.getTextareaField("Description")]);
  return myForm;
};

const AddCrossCollateralForm = () => {
  const myForm = addCrossCollateralFields(new BCFormController({}, { submitSuffix: "menu/cross-collateral", submitMethod: "POST" }));
  const formActions = ["save", "save-close", "delete", "close"];
  return <LmsFormGenerator myForm={ myForm } actions={ formActions } />;
};

const EditCrossCollateralForm = ({ id = "" }: IdProps) => {
  const [{ data = {}, isLoading, error }] = useFetchData(`menu/cross-collateral/${id}`);
  const myForm = addCrossCollateralFields(new BCFormController(data, { 
    submitSuffix: "menu/cross-collateral", 
    submitMethod: "PUT",
    deleteSuffix: "menu/cross-collateral",
  }));
  const formActions = ["save", "save-close", "delete", "close"];
  return (
    <LmsFormGenerator
      myForm={myForm}
      isLoading={isLoading}
      error={error}
      actions={formActions}
    />
  );
};

const LmsNewMenusCrossCollateral = ({ params = {}, history }) => {
  const { isMainPage, isAdd, isEdit, isActionAllowed, id } = useParseRouteActions(params);
  if (!isActionAllowed) {
    history.goBack();
  }

  return (<>
      {isMainPage && <LmsCrossCollateralTable />}
      {isAdd && <AddCrossCollateralForm />}
      {isEdit && <EditCrossCollateralForm id={id} />}
    </>);
};

export default LmsNewMenusCrossCollateral;
